import React, { useContext, useEffect } from 'react'
import decodeUrl from '../../utility-tools/decodeUrl';
import loadPageConfiguration from '../../utility-tools/loadPageConfiguration';
import { useNavigate } from 'react-router-dom';
import { PageConfigurationContext } from '../context/PageConfigurationContext';

const UseHandleUrlRoute = () => {
    const pageConfigurationCtx: any = useContext(PageConfigurationContext);
    const navigate = useNavigate();
    useEffect(() => {
        if (!window.location.search) {
          navigate('/');
        };
        if (!decodeUrl().hasOwnProperty('id')) {
            navigate('/');
          };
        loadPageConfiguration(decodeUrl()['id'], pageConfigurationCtx.set)
            .then(ConfigurationLoaded=>{
            if(!ConfigurationLoaded){
              navigate('/')
               }
            })
            .catch(error => {
              navigate('/500'); // Navigate to home or some error page
            });
      }, []);
  return (
1
  )
}

export default UseHandleUrlRoute